import { StatusEnum } from '@dermloop/static-values';
import {
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
} from 'class-validator';

export class BiopsySearchRequestDto {
  @IsOptional()
  @IsString()
  query?: string;

  @IsOptional()
  @IsEnum(StatusEnum)
  status?: StatusEnum;

  @IsOptional()
  @IsUUID('all', { each: true })
  biopsyTypes?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  skinTypes?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  clinicalDiagnosisIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  accurateDiagnosisIds?: string[];

  @IsOptional()
  @IsUUID()
  healthRecordId?: string;

  @IsOptional()
  @IsNumber()
  @Max(30)
  take?: number;

  @IsOptional()
  @IsNumber()
  skip?: number;
}

export class PatientSummaryDto {
  healthRecordId: string;
  genderId?: string;
  birthDate?: Date;
  firstName?: string;
  lastName?: string;
  skinTypeId?: string;
  ssn?: string;
  mrn?: string;
}

export class BiopsySearchResultItemDto {
  id?: string;
  patient: PatientSummaryDto;
  diagnosed: boolean;
  conditionId?: string;
  /** @deprecated Use conditionId */
  lesionId?: string;
  clinicalDiagnosisId?: string;
  histopathologicalDiagnosisId?: string;
  biopsyTypeName?: string;
  createdDate: Date;
  reference: string;
}
